import React, { useEffect, useState } from "react";
// import Link from "next/link";
import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";
import { baseUrl } from "api/constants";
import dynamic from "next/dynamic";
// import FtafatModal from "components/homePage/goodMorning/ftafatModal";
const FtafatModal = dynamic(() => import("components/homePage/goodMorning/ftafatModal"), { ssr: false });
import { useWindowSize } from "api/commonConstants";
// import BottomStripIPL from "components/cricket/ipl/BottomStripIPL";
const BottomStripIPL = dynamic(() => import("components/cricket/ipl/BottomStripIPL"), { ssr: false });

import { useSelector } from "react-redux";

// import ClevertapReact from "utils/clevertapHelper";

const MobileMenuBottom = () => {
  const size = useWindowSize();
  const [isKeyPresent, setIsKeyPresent] = useState(false);
  const keyToCheck = "RECENGINE"; // The key you want to check

  const { videoIsShow } = useSelector(({ SeriesReducer }) => SeriesReducer);
  const {recEngineClosedManually} = useSelector(({ CategoryReducer }) => CategoryReducer);

  const router = useRouter();
  const [activeTab, setActiveTab] = useState(
    router?.pathname.includes("/quiz")
      ? "quiz"
      : router?.pathname.includes("/short-video")
        ? "short-video"
        : router?.pathname.includes("/text")
          ? "text"
          : router?.pathname.includes("/audio")
            ? "audio"
            : router?.pathname.includes("/show")
              ? "show"
              : "all"
  );

  const { fatafat: openFatafat } = router.query;

  const [fatafatPosts, setFatafatPosts] = useState([]);
  const [scrollY, setScrollY] = useState(0);
  const [bottomBanner, setBottomBanner] = useState([]);
  const [closeFooterBanner, setCloseFooterBanner] = useState(false);

  const [showLiveAtBottom, setShowLiveAtBottom] = useState(false)
  const [showAdd , setShowAdd] = useState(true)
  const cross = () => {
    return <svg id="cross-icon" style={{
      cursor: 'pointer',
      position: 'absolute',
      top: '-34px',
      right: '0px',
      backgroundColor: 'white',
      borderTopLeftRadius: '10px'
    }} onClick={() => {
      setShowAdd(false)
    }} width="50" height="50" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.4766 20.0406L33.6956 33.2596" stroke="#292D32" stroke-width="2.11629" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.4763 33.2596L33.6953 20.0406" stroke="#292D32" stroke-width="2.11629" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
  } 

  const [shouldShow, setShouldShow] = useState(
    typeof openFatafat !== "undefined" && openFatafat === "true" ? true : false
  );
  const queryIndex = router.query?.index ? parseInt(router.query.index) : 0;
  const [firstScroll, setFirstScroll] = useState(false);

  useEffect(() => {
    router?.pathname.includes("/quiz")
      ? setActiveTab("quiz")
      : router?.pathname.includes("/short-video")
        ? "short-video"
        : router?.pathname.includes("/text")
          ? setActiveTab("text")
          : router?.pathname.includes("/audio")
            ? setActiveTab("audio")
            : router?.pathname.includes("/show")
              ? setActiveTab("show")
              : setActiveTab("all");
  }, [router?.pathname]);

  const [showFooter, setShowFooter] = useState(true);
  const [scrollDirection, setScrollDirection] = useState(null);



  useEffect(async () => {
    if (
      !router?.pathname?.includes("/post/") &&
      !router?.pathname?.includes("/video/")
    ) {
      const data = await fetch(
        `${baseUrl}/banner/all?source=WEB&category=floating-footer`
      );
      const amp = await data.json();
      const dat = amp?.result;
      setBottomBanner(dat);
    }
  }, [router?.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      // console.log("changing scroll");

      setScrollY(window?.scrollY);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    };
  }, [scrollDirection]);
  useEffect(() => {
    if (router.pathname.includes("/short-video")) {
      setActiveTab("short-video");
    }
    setShowFooter(
      router.pathname !== "/login" &&
      router.pathname !== "/vs/header_lt" &&
      router.pathname !== "/adda/schedule" &&
      router.pathname !== "/cricket-page" &&
      router.pathname !== "/preferences" &&
      router.pathname !== "/loading/profile" &&
      !router.pathname.includes("/app-view") &&
      !router.pathname.includes("/liveblog") &&
      !router.pathname.includes("/faq-app") &&
      !router.pathname.includes("/quiz/terms-and-conditions") &&
      !router.pathname.includes("/amp/") &&
      !router?.query?.shortId?.length
    );
  }, [router.pathname]);

  var shortsTabClicked = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        limit: 1,
        skip: 1,
      }),
    };
    await fetch(
      `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/short/list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        var result = data?.result?.entities;
        console.log("lalala", result);
        window.location.href = `/short-video/${result[0].postSlug}`;
        // router.push(`/short-video/${result[0].postSlug}`);
      });
  };
  // console.log("showfootermob", !router?.query?.shortId?.length);

  //Fatafat Logic

  useEffect(() => {
    function handleScroll() {
      setFirstScroll(true);
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    // pushGoogleTabEvent("homepage_fatafat_open", {});
    setShouldShow(false);
    router.push("/");
    // setShow((e) => !e);
  };
  const openHandler = () => {
    if (fatafatPosts && fatafatPosts?.length > 0) {
      setShouldShow(true);
      router.push(
        `?fatafat=${fatafatPosts[0]?.postSlug}&index=0`,
        `/${fatafatPosts[0]?.categorySlug}/post/${fatafatPosts[0]?.postSlug}`,
        { shallow: true }
      );
    } else {
      fatafatHandler();
      setShouldShow(true);
    }
  };

  useEffect(() => {
    console.log(router?.pathname);


  }, [])

  const fatafatHandler = () => {
    fetch(`${baseUrl}/post/allFatafat?limit=9&skip=1&type=text`)
      .then((res) => res.json())
      .then((d) => {
        setFatafatPosts(d?.result?.entities);
      });
  };

  useEffect(() => {
    if (shouldShow) {
      openHandler();
    }
  }, []);

  useEffect(() => {
    // Check if the key exists in the window object
    if (keyToCheck in window && !recEngineClosedManually) {
      setIsKeyPresent(true);
    } else {
      setIsKeyPresent(false);
    }
  }, [scrollDirection ,recEngineClosedManually]);

  useEffect(() => {
    if(videoIsShow){
      setActiveTab('show')
    }
  },[videoIsShow])


  return (
    <>
      {/* {router.asPath === "/"  && (
        <div className="stickyadcode" align="center">
          <Ads adName={"/1007232/Lallantop_HP_320x50_bottom"} />
        </div>
      )}
      {router.asPath !== "/" && (
        <div className="stickyadcode" align="center">
          <Ads adName={"/1007232/Lallantop_ROS_320x50_bottom"} />
        </div>
      )} */}
      {showFooter && (
        <>
          
          {!showLiveAtBottom && showAdd && (!router.pathname.includes("/audio")) &&
            < div
              className={`bottom-menu ${scrollDirection === "down" ? "FooterShow" : "FooterAdHide"
                }`}
              // style={{ bottom: "60px" }}
              style={{ bottom: scrollDirection !== "down" ? "77px" : isKeyPresent ? "123px" : "26px" }}
            >

              {cross()}
              {
                <div className="container-row py-2" align="center"> 
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#b7b7b7",
                      textAlign: "center",
                      marginBottom: "0rem",
                    }}
                    className="bg-white"
                  >

                    Advertisement
                  </p>
                  <div
                    id="div-gpt-ad-1701946324333-0"
                    style={{
                      minWidth: "300px",
                      minHeight: "60px",
                      display: "block !important",
                      alignContent: "center",
                      textAlign: "-webkit-center",
                    }}
                    className="bg-white"
                  >
                    <script
                      type="text/javascript"
                      dangerouslySetInnerHTML={{
                        __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})`,
                      }}
                    ></script>
                  </div>
                </div>
              }
            </div>
          }
          {(router.pathname.includes("/ipl") || router.pathname === "/") &&
            <>
              {showLiveAtBottom && <div
                className={`bottom-menu ${scrollDirection === "down" ? "FooterShow" : "FooterAdHide"
                  }`}
                // style={{bottom: "60px" }}
                style={{ bottom: scrollDirection !== "down" ? "83px" : isKeyPresent ? "123px" : "101px" }}
              >
                {
                  <div className="container-row py-2" align="center">
                    <p
                      style={{
                        fontSize: "11px",
                        color: "#b7b7b7",
                        textAlign: "center",
                        marginBottom: "0rem",
                      }}
                      className="bg-white"
                    >

                      Advertisement
                    </p>
                    <div
                      id="div-gpt-ad-1701946324333-0"
                      style={{
                        minWidth: "300px",
                        minHeight: "60px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center",
                      }}
                      className="bg-white"
                    >
                      <script
                        type="text/javascript"
                        dangerouslySetInnerHTML={{
                          __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})`,
                        }}
                      ></script>
                    </div>
                  </div>
                }
              </div>}
              {scrollDirection === "down" &&
                <div
                  className={`bottom-menu ${scrollDirection === "down" ? "FooterShow" : "FooterAdHide"
                    }`}
                  // style={{bottom: "60px" }}
                  style={{ bottom: scrollDirection !== "down" ? "85px" : isKeyPresent ? "114px" : "30px", background: "transparent", left: "10px" }}
                >
                  <BottomStripIPL setShowLiveAtBottom={setShowLiveAtBottom} />
                </div>
              }
            </>
          }
          <div
            className={`bottom-menu ${scrollDirection === "down" ? router.pathname.includes("/audio") ? "" : "FooterHide" : "FooterShow"
              }`}
          >
            <ul>
              <li
                className={activeTab === "all" && !shouldShow ? "active" : ""}
              >
                <a
                  href="/"
                  onClick={() => {
                    if (typeof window.ga !== "undefined") {
                      ga("create", "G-RXRPKR4310", "auto");
                      ga("send", "event", {
                        eventCategory: "bottom_menu",
                        eventAction: "Click",
                        eventLabel: "home",
                        eventValue: "https://www.thelallantop.com/",
                      });
                    }

                    setActiveTab("all");
                  }}
                >
                  {activeTab === "all" && !shouldShow ? (
                    <img
                      className="icon-home icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742895514831_home-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  ) : (
                    <img
                      className="icon-home icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742894786610_home-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  )}
                  <span>
                    <FormattedMessage id="home" defaultMessage="होम" />
                  </span>
                </a>
              </li>
              <li
                className={activeTab === "show" && !shouldShow ? "active" : ""}
              >
         
                <a
                  href="/show/all"
                  onClick={() => {
                    
                    if (typeof window.ga !== "undefined") {
                      ga("create", "G-RXRPKR4310", "auto");
                      ga("send", "event", {
                        eventCategory: "bottom_menu",
                        eventAction: "Click",
                        eventLabel: "shows",
                        eventValue: "https://www.thelallantop.com/show/all",
                      });
                    }
                    setActiveTab("show");
                  }}
                >
                  {activeTab === "show" && !shouldShow ? (
                    <img
                      className="icon-shows icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742895590628_video-play-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  ) : (
                    <img
                      className="icon-shows icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742894865346_video-play-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  )}
                 
                  <span>
                    <FormattedMessage id="shows" defaultMessage="शो" />
                  </span>
                </a>
          
              </li>
              <li className={shouldShow ? "active" : ""}>
                <a
                  href="/?fatafat=true"
                >

                  {shouldShow ? (
                    <img
                      className="icon-vidos icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742905773194_ftafat_(1)-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  ) : (
                    <img
                      className="icon-vidos icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742905597275_ftafat-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  )}
                  <span style={{ color: shouldShow ? "#D9368B" : "black" }}>
                    <FormattedMessage id="fatafat" defaultMessage="देखिए" />
                  </span>
                </a>
            
              </li>
              <li
                className={activeTab === "audio" && !shouldShow ? "active" : ""}
              >
                <a
                  href="/audio"
                  onClick={() => {
                
                    if (typeof window.ga !== "undefined") {
                      ga("create", "G-RXRPKR4310", "auto");
                      ga("send", "event", {
                        eventCategory: "bottom_menu",
                        eventAction: "Click",
                        eventLabel: "audio",
                        eventValue: "https://www.thelallantop.com/audio",
                      });
                    }
                    setActiveTab("audio");
                  }}
                >
                  {activeTab === "audio" && !shouldShow ? (
                    <img
                      className="icon-listen icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742895572359_microphone-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  ) : (
                    <img
                      className="icon-listen icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742894817738_microphone-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  )}
                  {/* <i className="icon-listen icon-padding"></i> */}
                  <span>
                    <FormattedMessage id="audios" defaultMessage="सुनिए" />
                  </span>
                </a>
        
              </li>
              <li
                className={
                  activeTab === "short-video" && !shouldShow ? "active" : ""
                }
              >
         
                <a
     
                  onClick={() => {
                    if (typeof window.ga !== "undefined") {
                      ga("create", "G-RXRPKR4310", "auto");
                      ga("send", "event", {
                        eventCategory: "bottom_menu",
                        eventAction: "Click",
                        eventLabel: "shorts",
                        eventValue: "https://www.thelallantop.com/short-video",
                      });
                    }
                    shortsTabClicked();
                  }}
                >
                  {activeTab === "short-video" && !shouldShow ? (
                    <img
                      className="icon-shows icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742895612841_3-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  ) : (
                    <img
                      className="icon-shows icon-padding"
                      src={
                        "https://static.thelallantop.com/images/post/1742894834784_note-2-min.webp"
                      }
                      width="20px"
                      height="20px"
                      alt="home"
                    />
                  )}
                 
                  <span>
                    <FormattedMessage id="shorts" defaultMessage="शॉर्ट्स" />
                  </span>
                </a>
                
              </li>
             
            
            </ul>
          </div>
        </>
      )
      }
      {
        fatafatPosts && fatafatPosts.length > 0 && shouldShow && (
          <FtafatModal
            show={shouldShow}
            fatafatPosts1={fatafatPosts}
            onClick={() => {
              handleClick();
            }}
            queryIndex={queryIndex}
          />
        )
      }
    </>
  );
};
export default MobileMenuBottom;
